import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import moment from 'moment';
import { AppState } from '../../common/_reducers';
import { Plant } from '../_models/plant';
import { environment } from '../../../environments/environment';
import { Crop } from '../_models/crop';
import { selectAllPlants } from '../_selectors/plant.selectors';

@Injectable()
export class PlantService {
  private apiBaseUrl = environment.apiBaseUrl;
  private plantList$: Observable<Plant[]>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>
  ) {
    this.plantList$ = store.select(selectAllPlants);
  }

  getFromLocalStore(): Observable<Plant[]> {
    return this.plantList$;
  }

  getPlants(): Observable<Plant[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/plants')
      .pipe(map((response) => response));
  }

  getPlant(id: number): Observable<Plant> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/plants/' + id)
      .pipe(map((response) => response));
  }

  savePlant(plantItem: Plant): Observable<Plant> {
    const plant = { ...plantItem };
    ////  console.log(plant, 'IN SERVICE');
    delete plant.lastUpdated;
    delete plant.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    plant.companyId = companySelected ? companySelected.id : null;

    const plantsUpdateDateFormatted = moment(plant.plantsUpdateDate)
      .startOf('day')
      .utc()
      .toISOString();
    plant.plantsUpdateDate = plantsUpdateDateFormatted
      ? plantsUpdateDateFormatted.replace(':00Z', ':00.000Z')
      : ('' as any);

    const plantsCuttingDateFormatted = moment(plant.plantsCuttingDate)
      .startOf('day')
      .utc()
      .toISOString();
    plant.plantsCuttingDate = plantsCuttingDateFormatted
      ? plantsCuttingDateFormatted.replace(':00Z', ':00.000Z')
      : ('' as any);

    if (plant.id) {
      if (plant.crops) {
        delete plant.crops;
      }
      return this.http
        .put<Plant>(this.apiBaseUrl + 'api/private/v1/plants/' + plant.id, plant)
        .pipe(map((response) => response));
    } else {
      if (plant.crops) {
        _.each(plant.crops, (crop: Crop) => {
          delete crop.lastUpdated;
          delete crop.dateCreated;
        });
      }
      return this.http
        .post<Plant>(this.apiBaseUrl + 'api/private/v1/plants', plant)
        .pipe(map((response) => response));
    }
  }

  deletePlant(id: number): Observable<Plant> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/plants/' + id).pipe(
      map(() => {
        return {
          id,
          rootstock: null,
          plantsCount: null,
          plantsX: null,
          plantsY: null,
          plantsUnit: null,
          plantsPlantingDate: null,
          plantsCuttingDate: null,
          plantsHarvestingDate: null,
          plantsUpdateDate: null,
          plantsNote: null,
          crops: null,
          dateCreated: null,
          lastUpdated: null,
        };
      })
    );
  }

  getMapKeyFromCrop(crop: Crop) {
    let mapKey: string = (crop.commodity?.id ?? '').toString();
    mapKey += (crop.variety?.id ?? '').toString();

    return mapKey;
  }

  getPlantsByCommodityAndVarietyIdFromField(crops: Array<Crop>) {
    const plantsByCommodityAndVarietyId: Map<string, Array<any>> = new Map();
    _.forEach(crops, (crop: Crop) => {
      if (crop.plant && crop.plant.id) {
        const mapKey = this.getMapKeyFromCrop(crop);
        const mapValue: Array<any> = plantsByCommodityAndVarietyId.get(mapKey.toString());
        const tmpObject = {
          id: crop.plant.id,
          commodityName: crop.commodity.name,
          varietyName: crop.variety
            ? crop.variety.name.substr(0, 1).toUpperCase() +
              crop.variety.name.substr(1).toLowerCase()
            : null,
          year: crop.year,
        };
        if (!mapValue) {
          plantsByCommodityAndVarietyId.set(mapKey.toString(), [tmpObject]);
        } else {
          mapValue.push(tmpObject);
          plantsByCommodityAndVarietyId.set(mapKey.toString(), mapValue);
        }
      }
    });
    return plantsByCommodityAndVarietyId;
  }
}
